import { useTranslation } from "react-i18next";
import styles from "./RealTimeSuggestionIndicator.module.css";

export interface RealTimeSuggestionIndicatorProps {
  isGenerating: boolean;
  enabled: boolean;
  onToggle: (enabled: boolean) => void;
  lastGeneratedAt: Date | null;
  disabled?: boolean;
}

export function RealTimeSuggestionIndicator({
  isGenerating,
  enabled,
  onToggle,
  lastGeneratedAt,
  disabled = false,
}: RealTimeSuggestionIndicatorProps) {
  const { t } = useTranslation();
  const formatTime = (date: Date) => {
    return date.toLocaleTimeString(undefined, {
      hour: "numeric",
      minute: "2-digit",
    });
  };

  return (
    <div className={styles.container}>
      <button
        type="button"
        className={`${styles.toggle} ${enabled ? styles.toggleEnabled : ""} ${disabled ? styles.toggleDisabled : ""}`}
        onClick={() => !disabled && onToggle(!enabled)}
        disabled={disabled}
        title={
          disabled
            ? t("editor.aiNotConnected")
            : enabled
              ? t("editor.disableRealTime")
              : t("editor.enableRealTime")
        }
      >
        <span
          className={`${styles.dot} ${enabled ? styles.dotEnabled : ""} ${isGenerating ? styles.dotGenerating : ""}`}
        />
        <span className={styles.label}>
          {isGenerating
            ? t("editor.analyzing")
            : enabled
              ? t("editor.realTime")
              : t("editor.manual")}
        </span>
      </button>
      {lastGeneratedAt && enabled && (
        <span className={styles.lastUpdated}>Last: {formatTime(lastGeneratedAt)}</span>
      )}
    </div>
  );
}
